import { Pagination } from "react-bootstrap";

function PaginationComponent({ pagination, currentPage, handlePageChange }) {
    if (!pagination || pagination.totalPages <= 1) return null;

    let items = [];

    // Calculate range to display
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(pagination.totalPages, currentPage + 2);

    // Ensure we always show 5 pages when possible
    if (endPage - startPage < 4) {
        if (startPage === 1) {
            endPage = Math.min(5, pagination.totalPages);
        } else if (endPage === pagination.totalPages) {
            startPage = Math.max(1, pagination.totalPages - 4);
        }
    }

    // First page
    if (startPage > 1) {
        items.push(
            <Pagination.Item
                key={1}
                onClick={() => handlePageChange(1)}
            >
                1
            </Pagination.Item>
        );
        if (startPage > 2) {
            items.push(<Pagination.Ellipsis key="ellipsis-1" />);
        }
    }

    // Main page range
    for (let i = startPage; i <= endPage; i++) {
        items.push(
            <Pagination.Item
                key={i}
                active={i === currentPage}
                onClick={() => handlePageChange(i)}
            >
                {i}
            </Pagination.Item>
        );
    }

    // Last page
    if (endPage < pagination.totalPages) {
        if (endPage < pagination.totalPages - 1) {
            items.push(<Pagination.Ellipsis key="ellipsis-2" />);
        }
        items.push(
            <Pagination.Item
                key={pagination.totalPages}
                onClick={() => handlePageChange(pagination.totalPages)}
            >
                {pagination.totalPages}
            </Pagination.Item>
        );
    }

    return (
        <div className="d-flex justify-content-center mt-4">
            <Pagination>
                <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                />
                <Pagination.Prev
                    onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                />
                {items}
                <Pagination.Next
                    onClick={() => handlePageChange(Math.min(pagination.totalPages, currentPage + 1))}
                    disabled={currentPage === pagination.totalPages}
                />
                <Pagination.Last
                    onClick={() => handlePageChange(pagination.totalPages)}
                    disabled={currentPage === pagination.totalPages}
                />
            </Pagination>
        </div>
    );
}

export default PaginationComponent;